// extracted by mini-css-extract-plugin
export default {"info":"GroupsList_info__WP-dn","link":"GroupsList_link__VBWbT"};